import { render, staticRenderFns } from "./TermsOfServiceSimplifiedChinese.vue?vue&type=template&id=2440a47a"
import script from "./TermsOfServiceSimplifiedChinese.vue?vue&type=script&lang=js"
export * from "./TermsOfServiceSimplifiedChinese.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports